/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'macbookpro': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" _fill="#C4FFF9" d="M116.357 96.978V49.569c0-1.435-1.109-2.569-2.57-2.569H36.211c-1.462 0-2.569 1.134-2.569 2.569v47.409H25v2.462c1.102 1.784 7.059 2.71 9.422 2.71h80.51c2.366 0 8.966-.926 10.068-2.71v-2.462h-8.643zM37.069 50.426h75.862v46.552H37.069V50.426z"/>'
  }
})
